import { projectFirestore} from "../firebase/config";
import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import Editor from 'react-simple-wysiwyg';

const Kontakt = () => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(false);
    const [content, setContent] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const contentCollection = collection(projectFirestore, 'kontakt');
                const snapshot = await getDocs(contentCollection);
                const text = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                setData(text);

                const contentObj = {};
                text.forEach(item => contentObj[item.id] = item.content);
                setContent(contentObj);

            } catch (err) {
                setError(err.message);
                console.error("Error fetching data:", err);
            }
        };

        fetchData();

    }, []);

    const handleInputChange = (id, value) => {
        setContent(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const submitForm = async (e, id) => {
        e.preventDefault();
        try {
            const docRef = doc(projectFirestore, "kontakt", id);
            await updateDoc(docRef, { content: content[id] });
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div>
            {error && <p>{error}</p>}
            {data.map((text) => {
                const { id } = text;

                return (
                    <div className="container" key={id}>
                        <div className="p-4 border mb-5">
                            <form onSubmit={(e) => submitForm(e, id)}>
                                <div className="input-form">
                                    <Editor value={content[id] || ""} onChange={(e) => handleInputChange(id, e.target.value)} />
                                    <button type="submit" className="btn btn-success mt-4">Uložit</button>
                                </div>
                            </form>
                        </div>

                        <div dangerouslySetInnerHTML={{ __html: content[id] }}></div>
                    </div>
                );
            })}
        </div>
    );
};

export default Kontakt;
